import { AnyErrorAction, AnySuccessAction } from './types';

export function getErrorMessageKey(errorAction: AnyErrorAction): string | undefined {
  return errorAction.type;
}

export function getSuccessMessageKey(successAction: AnySuccessAction): string | undefined {
  return successAction.type;
}
